import React from "react";

// BuyerBeacon Pro logo — a stylized beacon (lighthouse light) emitting amber rays
export default function Logo({ className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="relative h-7 w-7">
        <svg viewBox="0 0 32 32" className="h-full w-full">
          <defs>
            <radialGradient id="bb-glow" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="#e9c659" />
              <stop offset="60%" stopColor="#d4af37" />
              <stop offset="100%" stopColor="#1e1b4b" />
            </radialGradient>
          </defs>
          <circle cx="16" cy="16" r="14" fill="#1e1b4b" />
          <circle cx="16" cy="16" r="6" fill="url(#bb-glow)" />
          {/* light rays */}
          <g stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round">
            <line x1="16" y1="3" x2="16" y2="6.5" />
            <line x1="16" y1="25.5" x2="16" y2="29" />
            <line x1="3" y1="16" x2="6.5" y2="16" />
            <line x1="25.5" y1="16" x2="29" y2="16" />
            <line x1="6.5" y1="6.5" x2="9" y2="9" />
            <line x1="23" y1="23" x2="25.5" y2="25.5" />
            <line x1="25.5" y1="6.5" x2="23" y2="9" />
            <line x1="9" y1="23" x2="6.5" y2="25.5" />
          </g>
        </svg>
      </div>
      <span className="text-[15px] font-semibold tracking-tight text-[#1e1b4b]">
        BuyerBeacon<span className="ml-1 text-[#d4af37]">Pro</span>
      </span>
    </div>
  );
}
